import styled from '@emotion/styled';
import { ErrorsContextProvider, ValidationErrors } from 'components';
import { ROUTING_PATHS } from 'const';
import { useIntParam } from 'hooks';
import { Modal } from 'semantic-ui-react';
import { Link, generatePath, useLocation, useNavigate } from 'react-router';
import { Button, toast } from '@britishcouncil/react-admin';
import { useCallback, useEffect, useMemo } from 'react';
import { parseServerErrors } from 'utils';
import { lrwSessionStore } from 'store';

export const ReleaseLrwSession = () => {
  const sessionId = useIntParam('sessionId');
  const location = useLocation();
  const { lrwSessionDetails } = ROUTING_PATHS;
  const [releaseSession, { isSuccess, error: savingError, isLoading: isConfirming, reset }] =
    lrwSessionStore.service.useReleaseLrwSessionMutation();
  const navigate = useNavigate();
  const errors = useMemo(() => parseServerErrors(savingError), [savingError]);

  const goToLrwSessionDetails = useCallback(() => {
    navigate(generatePath(lrwSessionDetails.absolutePath, { sessionId }), {
      state: location.state,
    });
  }, [location.state, navigate, lrwSessionDetails.absolutePath, sessionId]);

  useEffect(() => {
    if (isSuccess) {
      toast({
        type: 'success',
        title: 'Success',
        message: 'Session released successfully',
      });
      goToLrwSessionDetails();
      reset();
    }
  }, [goToLrwSessionDetails, isSuccess, sessionId, reset]);

  return (
    <ErrorsContextProvider generalErrors={errors}>
      <Modal open size="tiny">
        <Modal.Header>Release session</Modal.Header>
        <Modal.Content>
          <S.ValidationErrors />
          <p>Are you sure you want to release this LRW Session?</p>
        </Modal.Content>

        <Modal.Actions>
          <Link
            to={generatePath(lrwSessionDetails.absolutePath, { sessionId })}
            state={location.state}
          >
            <Button compact type="reset" secondary>
              Cancel
            </Button>
          </Link>

          <Button
            compact
            color="blue"
            onClick={() => {
              releaseSession({ lrwSessionId: sessionId });
            }}
            loading={isConfirming}
            disabled={isConfirming}
          >
            Confirm
          </Button>
        </Modal.Actions>
      </Modal>
    </ErrorsContextProvider>
  );
};

const S = {
  ValidationErrors: styled(ValidationErrors)`
    &.ui.error.message {
      margin-bottom: 3rem;
    }
  `,
};
